import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=0f4229de&scoped=true&class=true"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js"
import style0 from "./DashboardNavbar.vue?vue&type=style&index=0&id=0f4229de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4229de",
  null
  
)

export default component.exports